import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/vant'
import './assets/css/base.css'
import wx from 'weixin-js-sdk';
import './rem/rem.js'
import axios  from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

Vue.prototype.$wx = wx
Vue.use({
  router,
  appid:'',
  responseType:'code',  
  scope:'snsapi_userinfo',
  redirectUrl:'',
  userInfo:true
})
 


Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
